<script lang="ts">
	import UnsupportedBrowser from './UnsupportedBrowser.svelte'
	import RibbonComponent, { type Ribbon } from './Ribbon.svelte'
	import Search from './Search.svelte'
	import DesktopMenu from './DesktopMenu.svelte'
	import Personal from './Personal.svelte'
	import SubMenu from './SubMenu.svelte'
	import { storefront_prefix } from 'shared/var'
	import type { get_map } from 'shared/json_api/get_related'
	import { onMount } from 'svelte'

	export let ribbons: Ribbon[] = []
	export let storefront_menu_items: ResourceTypes[`storefront_menu_item`][]
	export let included_map: ReturnType<typeof get_map>
	export let the_window: Window | null = null

	let active_menu_id: string | null = null
	let window_width: number

	const menu_href_prefix = `#menu_`

	onMount(() => {
		// when instantiated in ops, stop navigations to other pages
		if (the_window) {
			the_window.addEventListener(`click`, e => {
				const link = (e.target as HTMLElement).closest(`a[href]`) as HTMLAnchorElement | null
				if (!link) {
					return
				}

				if (!link.hash) {
					e.preventDefault()
					link.style.outline = `2px solid red`
					setTimeout(() => {
						// @ts-expect-error TS thinks outline is not nullable, and it's wrong
						link.style.outline = null
					}, 100)
				}
			})
		}

		if (!the_window) {
			the_window = window
		}
		const onHashChange = () => {
			const { hash } = the_window!.location
			active_menu_id = hash.startsWith(menu_href_prefix) ? hash.replace(menu_href_prefix, ``) : null
		}
		onHashChange()

		const onResize = () => {
			window_width = the_window!.innerWidth
		}
		onResize()

		the_window.addEventListener(`hashchange`, onHashChange)
		the_window.addEventListener(`resize`, onResize)

		return () => {
			the_window!.removeEventListener(`hashchange`, onHashChange)
			the_window!.removeEventListener(`resize`, onResize)
		}
	})

	const medium_skull_svg = (height: number) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -27.595 202.5 202.5" width="${ 162.5 * (height / 162.5) }" height="${ 162.5 * (height / 162.5) }">
	<rect
		x="-20"
		y="-27.595"
		width="202.5"
		height="202.5"
		fill="white"
	/>
	<polygon
		points="202.5, 202.5 202.5, 100 100, 202.5"
		fill="black"
	/>

  <path fill="black" d="M162.4,64.18c-.56-2.33-9.63-15.28-22.45-21.33s-29.52-11.96-35.99-16.77c-7.33-5.44-32.93-22.88-38.38-22.33-14.06,1.42-24.02-5.05-28.36-3.51C24.15,4.86,15.77,1.73,13.48,9.27,10.06,20.53.48,18.61.17,28.97c-.31,10.36-.67,13.4,3.37,12.97s9.19-.01,9.02,4.15c-.11,2.84-3.5,7.44-5.78,11.11-1.87,2.7-3.85,6.31-5.85,10.94-1.79,4.14,4.01,7.31,9.55,12.25,6.28,5.6,6.24,13.76,7.98,18.39,1.21,3.21,8.83,12.02,18.47,17.83,9.63,5.81,23.89,10.19,31.91,13.61s27.83,14.44,31.1,16.31c3.27,1.87,14.65.03,21.71-2.33,3.35-1.12,8.44-6.95,10.42-10.58,2.09-2.76,3.54-6.44,3.67-13.69-3.91,6-8.65,10.94-13.49,10.67-1.2-.1-2.38-.23-3.52-.39,2.26-2.9,3.84-6.52,3.76-11-4.83,5.96-11.33,9.36-14.96,8.23-.87-.31-1.72-.64-2.55-.99,2.3-2.72,3.96-6.18,4.13-10.51-4.16,4.59-9.32,7.96-12.04,6.46-.94-.58-1.85-1.18-2.72-1.79,2.29-2.48,4.03-5.65,4.5-9.71-3.55,3.36-8.37,6.56-10.34,5.06-1.05-.95-2.03-1.91-2.94-2.85,2.26-2.15,4.07-4.96,4.89-8.62-3.73,2.84-8.28,4.29-10.06,2.58-2.76-3.64-4.28-6.39-4.77-6.95-1.96-2.25-4.82-8.72-8.95-12.24-4.13-3.52-5.77-4.42-11.52-8.76-.02-.01-.03-.03-.05-.04,1.85-1.01,3.7-2.03,5.38-2.65,2.98-1.09,14.7-3.87,21.07.31,1.8,1.18,4.95,3.44,8.96,5.97,2.24,2.4-1.95,5.3-4.83,7.89,4.72-.24,8.36-1.89,11.16-4.15,1.16.64,2.35,1.27,3.58,1.88,0,0,0,0,0,0,3.11,1.33-1.48,6.15-5.06,9.26,5.93-.19,10.22-2.62,13.28-5.74,1.6.57,3.23,1.07,4.87,1.49,2.86.88-1.85,6.7-5.82,10.42,7.51-.53,12.23-4.57,15.16-8.96,1.39.08,2.78.11,4.16.08,3.89-.21-1.37,8.37-5.89,12.66,10.38-.8,15.37-8.28,17.7-14.09,1.67-.36,3.29-.76,4.84-1.22,2.14.28-2.16,9.71-6.42,14.14,12.65-1.43,17.32-13.08,18.92-19.2.49-.27.96-.55,1.4-.81,2.63-1.62,2.76-5.26,3.15-6.43.39-1.17,2.25-13.41,1.69-15.75ZM59.41,53.28c-2.82,2.5-8.03,1.49-13.51.98-4.58-.43-11.9,1.56-11.92-2.26-.02-3.65-4.12-4.52.93-6.17,1.64-.54,12.22-3.92,14.37-5.06,1.92-1.02,2.32-6.73-2.78-7.09-3.58-.25-17.62-3.85-17.86-7.89-.35-5.82,5.54-4.49,12.88-9.01,2.49-1.53,13.12.89,13.99,1.11,4.14,1.08,3.48,4.36,2.86,7.01-1.11,4.76.92,8.26,3.94,12.02,3.01,3.75,1.42,12.52-2.89,16.35ZM138.93,54.6c.62-.57,2.11-.33,2.79.12,2.44,1.62,5.47,4.2,7.85,5.91,3.57,2.57,3.56,5.44,2.47,8.94-2.65-2.42-12-6.72-15.18-8.44-4.3-2.34,1.46-5.97,2.07-6.53ZM79.86,53.88c-3.79-3.06-.64-5.83-.27-10.4.41-5.21-11.26-13.91-5.3-17.05,6.13-3.23,17.65,7.7,25.16,12.34,5.2,3.21,15.12,7.69,12.36,13.73-.42.92-9.7-2.98-10.04.91.35,8.58-5.45,4.13-9.87,2.81-5.51-1.63-9.66-.43-12.04-2.34Z"/>
</svg>`

</script>

<UnsupportedBrowser />

{#each ribbons as ribbon}
	<RibbonComponent {ribbon} />
{/each}

<div class="header">
	<div class="header_content">
		<div class="desktop flex_horizontal" style="flex-grow: 1; gap: 10px; align-items: start;">
			<a href={storefront_prefix} class="flex_horizontal logo" style="align-items: center" aria-label="T.REX ARMS">
				{@html medium_skull_svg(88)}
			</a>

			<div class="flex_vertical">
				<Search />

				<div class="flex_horizontal">
					<DesktopMenu {storefront_menu_items} {included_map} {active_menu_id} {menu_href_prefix} />

					<Personal />
				</div>
			</div>
		</div>

		<div class="mobile flex_vertical">
			<div class="flex_horizontal" style="gap: 5px;">
				<a href={storefront_prefix} class="logo flex_horizontal" style="flex-grow: 1">
					{@html medium_skull_svg(22)}

					<span style="flex-grow: 1">T.REX ARMS</span>
				</a>

				<Personal />

				<a class="hamburger" href="{ active_menu_id ? `#` : `${ menu_href_prefix }mobile` }" aria-label="Menu">
					{#if active_menu_id}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="2 0 20 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
					{:else}
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 4 20 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"><line x1="0" y1="12" x2="24" y2="12"></line><line x1="0" y1="6" x2="24" y2="6"></line><line x1="0" y1="18" x2="24" y2="18"></line></svg>
					{/if}
				</a>
			</div>

			<Search />
		</div>
	</div>

	{#if active_menu_id}
		<SubMenu {storefront_menu_items} {included_map} {active_menu_id} {window_width} {menu_href_prefix} />
	{/if}
</div>

<style>
	.header {
		background-color: black;
		font-family: 'Protipo', sans-serif;
		--header-height: 110px;
		/* so it's above the body of the page, which is blurred when the submenu is open */
		position: relative;
		z-index: 1;
	}

	.flex_horizontal {
		display: flex;
		justify-content: space-between;
		gap: 20px;
	}

	.flex_vertical {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex-grow: 1;
	}

	.header_content {
		align-items: stretch;
		padding: 10px 10px 10px 0;
		max-width: 1040px;
		margin: 0 auto;
	}

	.logo {
		text-decoration: none;
		gap: 6px;
		align-items: start;
	}

	.mobile .logo {
		padding: 0 2px;
	}
/*
	.mobile .logo :global(svg) {
		margin-bottom: -2px;
	} */

	.logo span {
		text-decoration: none;
		color: #999;
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 1px;
		line-height: 20px;
		font-family: 'Protipo Compact';
	}

	.mobile {
		display: none;
	}

	.hamburger {
		border: 0;
		background: none;
		padding: 0 5px;
		margin: 0;
		color: white;
		cursor: pointer;
		line-height: 40px;
		display: flex;
		align-items: center;
	}

	@media (max-width: 1000px) {
		.header {
			--header-height: 105px;
		}

		.header_content {
			padding: 10px;
		}

		.flex_vertical {
			gap: 5px;
		}

		.mobile {
			display: flex;
		}
		.desktop {
			display: none;
		}
	}
</style>
